import EmissionGraphTemplate from './template';
import { DomWeakMapUtil } from '../utils/dom';

export default class EmissionGraph { // eslint-disable-line no-unused-vars
    constructor(graphWrapper, disclaimerWrapper, data, options) {
        this.unitLabel = data.co2Label || '';
        this.unitValue = data.co2Value || '';
        this.rating = data.rating || '';

        this.barNumber = data.emissionBands.length;

        this.barList = data.emissionBands;
        this.barGap = 4;
        this.barUnit = 28;

        this.graphWrapper = graphWrapper;
        this.disclaimerWrapper = disclaimerWrapper;

        this.prefixString = '';

        if (options && options.prefixString) {
            this.prefixString = options.prefixString;
        }

        this.create();
    }

    create() {
        this.compute();
        this.render();
    }

    update() {
        const {
            rating,
            co2Disclaimer,
        } = this;

        const currentActive = this.graphWrapper.querySelector('.bar-item.active');
        const currentBand = currentActive ? currentActive.getAttribute('id').split('rating-')[1] : null;

        if (currentActive && currentBand === rating) {
            this.setActive(currentActive, false);
        } else {
            if (currentActive) {
                this.resetCurrentActive(currentActive);
            }

            const newActive = document.getElementById(`${this.prefixString}rating-${rating}`);
            this.setActive(newActive, true);
        }

        if (co2Disclaimer) {
            this.disclaimerWrapper.innerHTML = co2Disclaimer;
        }
    }

    setActive(barItem, isNewBar) {
        const item = barItem;

        if (isNewBar) {
            Object.assign(item.style, {
                width: `${this.activeWidth}px`,
                height: `${this.activeHeight}px`,
            });
            const itemArrow = item.querySelector('.bar-arrow');
            Object.assign(itemArrow.style, {
                left: `${this.activeWidth}px`,
                borderWidth: `${this.activeOffsetArrowWidth}px`,
            });

            item.classList.add('active');
        }

        item.querySelector('.bar-unit-label').innerHTML = this.co2Value || this.unitValue ? this.unitLabel : '';
        item.querySelector('.bar-unit-value').textContent = this.co2Value ? this.co2Value : this.unitValue;
    }

    resetCurrentActive(currentActive) { // eslint-disable-line class-methods-use-this
        const current = currentActive;
        const baseParams = DomWeakMapUtil(current, 'baseParams');
        const { width, height, offsetArrowWidth } = baseParams;

        Object.assign(current.style, {
            width: `${width}px`,
            height: `${height}px`,
        });

        current.classList.remove('active');

        const barItemArrow = current.querySelector('.bar-arrow');
        Object.assign(barItemArrow.style, {
            left: `${width}px`,
            borderWidth: `${offsetArrowWidth}px`,
        });

        current.querySelector('.bar-unit-value').textContent = null;
        current.querySelector('.bar-unit-label').textContent = null;
    }

    compute() {
        if (this.barNumber) {
            if (this.barNumber > 9) {
                this.barGap = 2;
                this.barUnit = 20;
            }

            this.computeOffset();
            this.computeActiveParams();
        }
    }

    computeOffset() {
        this.offset = ((this.barNumber - 1) * this.barGap);
        this.offsetSpace = (this.offset > this.barUnit ? this.barUnit - this.offset : 0);
        this.offsetWidth = this.barUnit / 2;
        this.offsetArrow = this.barUnit / 2;
    }

    computeActiveParams() {
        const {
            barNumber,
            barUnit,
            offsetSpace,
            offsetArrow,
        } = this;

        this.activeWidth = (barNumber + 1) * barUnit + offsetSpace;
        this.activeHeight = 2 * barUnit;
        this.activeOffsetArrowWidth = offsetArrow * 2;
    }

    render() {
        const htmlParser = new DOMParser();

        if (this.barList && this.barList.length) {
            this.barList.forEach((item, index) => {
                const barItemTemplate = htmlParser.parseFromString(EmissionGraphTemplate.template(item, this.prefixString), 'text/html');
                const barItem = barItemTemplate.body.firstChild;

                this.updateStyle(barItem, item, index);
                this.graphWrapper.appendChild(barItem);
            });
        }
    }

    updateStyle(barItem, item, index) {
        const {
            barUnit,
            barGap,
            offsetSpace,
            offsetWidth,
            offsetArrow,
        } = this;

        const { colorCode } = item;

        const width = ((index + 2) * barUnit) + offsetWidth + offsetSpace;
        const height = barUnit;
        const offsetArrowWidth = offsetArrow;

        Object.assign(barItem.style, {
            backgroundColor: colorCode,
            width,
            height,
            marginBottom: barGap,
        });

        const barItemArrow = barItem.querySelector('.bar-arrow');

        Object.assign(barItemArrow.style, {
            left: width,
            borderWidth: offsetArrowWidth,
            borderLeftColor: colorCode,
        });

        DomWeakMapUtil(barItem, 'baseParams', {
            width,
            height,
            offsetArrowWidth,
        });
    }
}

window.EmissionGraph = EmissionGraph;
